import { render, staticRenderFns } from "./NewsletterList.vue?vue&type=template&id=79b970af&scoped=true"
import script from "./NewsletterList.vue?vue&type=script&lang=js"
export * from "./NewsletterList.vue?vue&type=script&lang=js"
import style0 from "./NewsletterList.vue?vue&type=style&index=0&id=79b970af&prod&lang=scss"
import style1 from "./NewsletterList.vue?vue&type=style&index=1&id=79b970af&prod&lang=css"
import style2 from "./NewsletterList.vue?vue&type=style&index=2&id=79b970af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b970af",
  null
  
)

export default component.exports